// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__euQtI","footer":"Form_footer__1VPqN"};